// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__PLLLV","content":"styles_content__mfoCn","title":"styles_title__a5t1J","description":"styles_description__DmCYg","location":"styles_location__46ew2"};